import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClientService } from "./http-client.service";
import { tap } from "rxjs/operators";

@Injectable()
export class PaybookService {
  constructor(private http: HttpClientService) {}

  getAllUsers(): Observable<any> {
    return this.http
      .get("/api/validation_processes/open_banking/paybook_credentials/recover_users")
      .pipe(tap((_) => console.log("PaybookService.getAllUsers: Ok.")));
  }

  createUser(person_id): Observable<any> {
    const options = {
      person_id: person_id,
    };
    return this.http
      .post("/api/validation_processes/open_banking/paybook_credentials/create_user", options)
      .pipe(tap((_) => console.log("PaybookService.createUser: Ok.")));
  }

  createSession(id_user): Observable<any> {
    const options = {
      customer_id: id_user,
    };
    return this.http
      .post("/api/validation_processes/open_banking/paybook_credentials/create_paybook_token", options)
      .pipe(tap((_) => console.log("PaybookService.createSession: Ok.")));
  }

  public postCredential(
    bank_id: any,
    credentials: any,
    token: string,
    customer_id: string,
    username: any,
    validation_process_id: number
  ): Observable<any> {
    const options = {
      validation_process_id: validation_process_id,
      credentials: credentials,
      credential: {
        bank_id: bank_id,
        token: token,
        customer_id: customer_id,
        username: username,
      },
    };
    return this.http
      .post("/api/validation_processes/open_banking/paybook_credentials", options)
      .pipe(tap((_) => console.log("PaybookService.postCredential: Ok.")));
  }

  public getCredentialStatus(token, job_id, customer_id): Observable<any> {
    const options = {
      params: {
        token: token,
        job_id: job_id,
        customer_id: customer_id,
      },
    };
    return this.http
      .get("/api/validation_processes/open_banking/paybook_credentials/recover_status", options)
      .pipe(tap((_) => console.log("PaybookService.getCredentialStatus: Ok.")));
  }

  public createPaybookCredential(person_id, credential_id, username, customer_id, bank_id): Observable<any> {
    const options = {
      person_id: person_id,
      credential_id: credential_id,
      credential: {
        username: username,
        customer_id: customer_id,
        open_banking_bank_id: bank_id,
      },
    };
    return this.http
      .post("/api/validation_processes/open_banking/paybook_credentials", options)
      .pipe(tap((_) => console.log("PaybookService.putPaybookCredential: Ok.")));
  }

  public putPaybookCredential(credential_id, status, code, code_description) {
    const options = {
      credential: {
        status: status,
        code: code,
        error: code_description,
      },
    };
    return this.http
      .put("/api/validation_processes/open_banking/paybook_credentials/" + credential_id, options)
      .pipe(tap((_) => console.log("PaybookService.putPaybookCredential: Ok.")));
  }

  public sendTokenParams(credentials, customer_id, job_id, token) {
    const options = {
      user_information: {
        customer_id: customer_id,
        job_id: job_id,
        token: token,
      },
      credentials: credentials,
    };
    return this.http
      .post("/api/validation_processes/open_banking/paybook_credentials/post_token_params", options)
      .pipe(tap((_) => console.log("PaybookService.putPaybookCredential: Ok.")));
  }
}
